import React, { useState, useEffect, useRef } from "react";
import Heading from "../../elements/heading";
import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";
import BodyText from "../../elements/body-text";
import "./style.scss";
import api from "../../utils/api";
import { connect } from "react-redux";
import RadioButtonGroup from "../../elements/radio-button-group";
import ArvatoWidget from "../arvato-widget";
import { Icon } from "../../elements";
import BankCardInformation from "../bank-card-information";
import ConfirmationModal from "../../react-components/confirmation-modal";
import PrimaryLink from "../../elements/primary-link";
import { selectUserState } from "../../selectors/application";
import { S_AUTH_TOKEN, S_GEAR_SAVE_PAYMENT, webStorage } from "../../utils/webStorage";
import { getBankCardOptions } from "../../services/userService";
import { bankCardSubTypes } from "../../utils/lynkco-constants";
const CardInfo = ({
  user,
  onSubmit,
  arvatoOptions,
  heading,
  headingType,
  ctaNameSubmit,
  colorSchemeSubmit,
  iconNameSubmit,
  removeCardModal,
  termsConditionsLabel,
  termsConditionsBody,
  savePaymentLabel,
  savePaymentBody,
  disclaimer,
  paymethodMissingMessage,
  termsCheckbox,
  paymentInfoCheckbox,
  ctaNameAddCard,
  colorSchemeAddCard,
  iconNameAddCard,
  cardExpiredText
}) => {
  const [bankCards, setBankCards] = useState([]);
  const [showCardForm, setShowCardForm] = useState(true);
  const [selectedBankCard, setSelectedBankCard] = useState(null);
  const arvatoWidget = useRef();
  const [submitting, setSubmitting] = useState(false);
  const isAgreeToTerms = useRef();
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [agreedToTermsHasError, setAgreedToTermsHasError] = useState(false);
  const [savePayment, setSavePayment] = useState(false);
  const [editCard, setEditCard] = useState(null);
  const [showRemoveCardModal, setShowRemoveCardModal] = useState(false);
  const [removeCardError, setRemoveCardError] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    getBankCards();
    return () => {
      webStorage.clear(S_GEAR_SAVE_PAYMENT);
    };
  }, []);
  useEffect(() => {
    webStorage.set(S_GEAR_SAVE_PAYMENT, savePayment);
  }, [savePayment]);
  const getBankCards = async () => {
    const token = webStorage.get(S_AUTH_TOKEN);
    if (token) {
      const cards = await getBankCardOptions();
      if (cards.length > 0) {
        setShowCardForm(false);
        setBankCards(cards);
        let _card = cards.find(x => x.data.defaultFlag == "1");
        if (!_card) {
          _card = cards[0];
        }
        setSelectedBankCard(_card);
      } else {
        setBankCards([]);
        setShowCardForm(true);
        arvatoWidget.current.init();
      }
    } else {
      setShowCardForm(true);
      arvatoWidget.current.init();
    }
  };
  const termsProps = {
    label: termsConditionsLabel.value,
    infoText: termsConditionsBody.value,
    error: agreedToTermsHasError,
    checked: agreeToTerms,
    onChange: checked => {
      setAgreeToTerms(checked);
      isAgreeToTerms.current = checked;
      setAgreedToTermsHasError(false);
    }
  };
  const paymentInfoProps = {
    label: savePaymentLabel.value,
    infoText: savePaymentBody.value,
    checked: savePayment,
    onChange: checked => {
      setSavePayment(checked);
    }
  };
  const submitButtonProps = {
    buttonText: ctaNameSubmit.value,
    iconName: iconNameSubmit,
    colorScheme: colorSchemeSubmit,
    isDisabled: submitting,
    callback: async evt => {
      let isValid = true;
      if (!selectedBankCard && !showCardForm) {
        setError(paymethodMissingMessage.value);
        isValid = false;
      }
      if (termsCheckbox.value && !isAgreeToTerms.current) {
        setAgreedToTermsHasError(true);
        isValid = false;
      }
      setSubmitting(true);
      if (selectedBankCard) {
        console.log("selectedBankCard.card", selectedBankCard.data);
        await onSubmit({ isValid, paymentRegistrationToken: selectedBankCard.data.registrationNo, bankCardId: selectedBankCard.data.id });
        setSubmitting(false);
      } else if (showCardForm) {
        arvatoWidget.current.submit();
      }
    }
  };
  const onRemoveCardClick = (evt, card) => {
    evt.stopPropagation();
    setEditCard(card);
    setShowRemoveCardModal(true);
  };
  const onBankCardChange = option => {
    setSelectedBankCard(option);
    setShowCardForm(false);
    setError(null);
  };
  const addCardCtaProps = {
    buttonText: ctaNameAddCard.value,
    colorScheme: colorSchemeAddCard,
    iconName: iconNameAddCard,
    callback() {
      setShowCardForm(true);
      setSelectedBankCard(null);
      arvatoWidget.current.init();
    }
  };
  const arvatoWidgetProps = {
    arvatoOptions: arvatoOptions.fields,
    visible: showCardForm,
    ref: arvatoWidget,
    user: user,
    onSubmit: async paymentToken => {
      let isValid = true;
      if (termsCheckbox.value && !isAgreeToTerms.current) {
        setAgreedToTermsHasError(true);
        isValid = false;
      }
      setSubmitting(true);
      await onSubmit({ isValid, paymentToken, savePayment });
      setSubmitting(false);
    }
  };
  const removeCardModalProps = removeCardModal && {
    heading: {
      type: removeCardModal.fields.headingType,
      html: removeCardModal.fields.headingBody
    },
    subHeading: {
      type: removeCardModal.fields.subheadingType,
      html: removeCardModal.fields.subheadingBody
    },
    body: removeCardModal.fields.body.value,
    button: {
      ...{
        colorScheme: removeCardModal.fields.colorScheme,
        iconName: removeCardModal.fields.iconName,
        link: {
          value: {
            text: removeCardModal.fields.ctaName.value
          }
        },
        callback: async evt => {
          await api.user.deleteBankCard(null, { bankCardIds: [editCard.id] });
          setShowRemoveCardModal(false);
          setEditCard(null);
          await getBankCards();
        }
      }
    },
    warningMessage: removeCardError,
    onCloseClicked: () => {
      setShowRemoveCardModal(false);
      setRemoveCardError(null);
    },
    showModal: showRemoveCardModal
  };
  const bankCardLayout = option => {
    if (option.data) {
      return (
        <div className="bank-card-contianer">
          <BankCardInformation {...{ card: option.data, expiredText: cardExpiredText.value }} />
          <div className="icons">{selectedBankCard !== option && option.data.cardSubType !== bankCardSubTypes.actived && bankCards.length > 1 && <Icon name="Delete" colorScheme="outline-green" className="icon --visible" onClick={evt => onRemoveCardClick(evt, option.data)} />}</div>
        </div>
      );
    } else {
      return <p className="label">{option.label}</p>;
    }
  };
  return (
    <section className="card-info">
      <div className="title">
        <Heading type={headingType} html={heading} />
      </div>
      <RadioButtonGroup options={bankCards} html={bankCardLayout} alignment="top" onChange={e => onBankCardChange(e)} selectedOption={selectedBankCard} />
      {!showCardForm && (
        <div className="add-payment-cta">
          <PrimaryLink {...addCardCtaProps} />
        </div>
      )}
      <div className="widget-container">
        <ArvatoWidget {...arvatoWidgetProps} />
      </div>
      {termsCheckbox.value && <Checkbox {...termsProps} />}
      {paymentInfoCheckbox.value && user?.userAccount && !selectedBankCard && <Checkbox {...paymentInfoProps} />}
      {error && <div className="failed-message">{error}</div>}
      <div className="submit">
        <PrimaryButton {...submitButtonProps} />
      </div>
      <BodyText html={disclaimer.value} className="body-text" />
      <ConfirmationModal {...removeCardModalProps} />
    </section>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state)
});
export default connect(mapStateToProps)(CardInfo);
//
// CardInfo.propTypes = {
//   heading: PropTypes.shape(PropTypeHeading),
//   cardType: PropTypeDropdown,
//   cardIcons: PropTypes.array,
//   cardHolderName: PropTypeInput,
//   cardNumber: PropTypeInput,
//   cardExpiryDate: PropTypeInput,
//   cardCVC: PropTypeInput,
//   termsCheckbox: PropTypeCheckbox,
//   paymentInfoCheckbox: PropTypeCheckbox,
//   submit: PropTypePrimaryButton,
//   disclaimer: PropTypes.object
// };
